import axios from 'axios';

const defaultAxios = axios.create({
	baseURL:
		import.meta.env.VITE_BRANCH_NAME === 'localhost'
			? 'http://localhost:8080'
			: import.meta.env.VITE_BRANCH_NAME
				? `https://${import.meta.env.VITE_BRANCH_NAME}---oto-web-rest-api-qa-2yycsthcma-ew.a.run.app`
				: import.meta.env.VITE_API_URL,
	headers: {
		'X-platform': import.meta.env.VITE_PLATFORM === 'web' ? 'oto-web' : 'oto-desktop',
		'X-platform-version': import.meta.env.VITE_APP_VERSION
	}
});

export const axiosAuth = axios.create({
	baseURL: import.meta.env.VITE_LOGIN_URL,
	headers: {
		'X-platform': import.meta.env.VITE_PLATFORM === 'web' ? 'oto-web' : 'oto-desktop',
		'X-platform-version': import.meta.env.VITE_APP_VERSION
	}
});

export const openAxios = axios.create({
	baseURL:
		import.meta.env.VITE_BRANCH_NAME === 'localhost'
			? 'http://localhost:8080'
			: import.meta.env.VITE_BRANCH_NAME
				? `https://${import.meta.env.VITE_BRANCH_NAME}---oto-web-rest-api-qa-2yycsthcma-ew.a.run.app`
				: import.meta.env.VITE_API_URL,
	headers: {
		'X-platform': import.meta.env.VITE_PLATFORM === 'web' ? 'oto-web' : 'oto-desktop',
		'X-platform-version': import.meta.env.VITE_APP_VERSION
	}
});

export const sallaAxios = axios.create({
	baseURL: 'https://api.salla.dev/admin/v2'
});

sallaAxios.interceptors.response.use(
	(response) => response.data,
	(error) => {
		return Promise.reject(error);
	}
);

export const setAuthorizationToken = (token) => {
	if (token) {
		if (import.meta.env.VITE_BRANCH_NAME) {
			defaultAxios.defaults.headers.common['x-forwarded-authorization'] = `Bearer ${token}`;
		} else {
			defaultAxios.defaults.headers.common.authorization = `Bearer ${token}`;
		}
	} else {
		delete defaultAxios.defaults.headers.common.authorization;
	}
};

export default defaultAxios;
